<div class="mct-flex mct-col mct-justify-center mct-items-start mct-gap-16">
  <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-stretch mct-gap-16">
    <div class="mct-flex mct-col mct-basis-50">
      <div class="light-text">{{ 'banner-ads.search.keyword' | translate | titlecase }}</div>
      <div>
        <input
          type="text"
          placeholder="{{ 'banner-ads.search.keyword-placeholder' | translate | ucfirst }}"
          class="form-control w-100"
          [(ngModel)]="searchParams.AdKeyword"
        />
      </div>
    </div>
    <div class="mct-flex mct-col mct-basis-50">
      <div class="light-text">{{ 'banner-ads.search.profile-name' | translate | titlecase }}</div>
      <div>
        <input
          type="text"
          placeholder="{{ 'banner-ads.search.profile-name-placeholder' | translate | ucfirst }}"
          class="form-control w-100"
          [(ngModel)]="searchParams.ProfileName"
        />
      </div>
    </div>
  </div>
  <div class="mct-flex mct-col mct-justify-center mct-items-start mct-gap-4">
    <div class="light-text">{{ 'banner-ads.search.banner-start-date' | translate | ucfirst }}</div>
    <div class="mct-grid banner-search-grid">
      <div>
        <wl-date-selector #startDate [(ngModel)]="searchParams.SearchStartDate"></wl-date-selector>
      </div>
      <div class="mct-flex light-text mct-justify-center mct-items-center">{{ 'banner-ads.search.through' | translate }}</div>
      <div>
        <wl-date-selector #endDate [(ngModel)]="searchParams.SearchEndDate"></wl-date-selector>
      </div>
    </div>
  </div>
</div>
